import React, { useContext } from 'react';
import {
  Dialog,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Box,
  MenuItem,
  Select,
  FormControl,
} from '@mui/material';

import { useState, useEffect, useRef } from 'react';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import {
  fontWeightBold,
  poppins400,
  poppins500,
  poppins700,
} from 'theme/common.style';
import {
  Button,
  useMediaQuery,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import { REQUEST_DEPOSIT } from 'constant/app.config';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Loading from 'assets/images/loading.png';

const PaymentHistoryPopup = ({
  open,
  onClose,
  actionBuyerId,
  actionBuyer,
  getTableData,
  isFromBuyerRegister,
  setActionBuyer,
  setActionBuyerId,
  confirmAmount,
  isDetailsIndividual,
  getDetailsData,
  setPaymentHistoryPopup,
  getListInfo,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // detects screen width < 600px
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches400 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
    fontWeight: 400,
  };

  const { setDisplayExchange } = useContext(PropertyContext);

  const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState('');
  const [amountInput, setAmountInput] = useState('');
  const [method, setMethod] = useState('EFT');
  const [notes, setNotes] = useState('');
  const [errors, setErrors] = useState({ amount: '', method: '', notes: '' });

  const claerState = () => {
    setErrors('');
    setAmount('');
    setMethod('');
    setNotes('');
  };

  const CommaSeprateValue = (val) => {
    return val?.toLocaleString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  useEffect(() => {
    setAmountInput(
      isDetailsIndividual
        ? confirmAmount?.unformattedNeedToConfirmAmount
        : actionBuyer?.unformattedNeedToConfirmAmount
    );
    setAmount(
      isDetailsIndividual
        ? confirmAmount?.needToConfirmAmount?.replace(/[$,]/g, '') ?? null
        : actionBuyer?.needToConfirmAmount?.replace(/[$,]/g, '') ?? null
    );
    setMethod(
      isDetailsIndividual
        ? confirmAmount?.buyerDepositType
        : actionBuyer?.buyerDepositType
    );
  }, [open]);

  const [contractAppLoader, setContractAppLoader] = useState(false);

  // Function to handle input and add commas
  const handleAmountChange = (e) => {
    let value = e.target.value;
    // Remove all non-numeric characters
    value = value.replace(/\D/g, '');
    if (/^0{2,}/.test(value)) return;
    const numericValue = Number(value);
    const confirmValue = isDetailsIndividual
      ? confirmAmount?.unformattedNeedToConfirmAmount
      : actionBuyer?.unformattedNeedToConfirmAmount;
    if (confirmValue != null && numericValue > confirmValue) {
      return;
    }
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    setAmount(formattedValue);
    setAmountInput(numericValue);

    // Validation messages
    if (value === '' || value == 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        amount: (
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '12px', fontWeight: 500 }}
          >
            Amount is required.
          </Typography>
        ),
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        amount: '',
      }));
    }
  };

  const handleMethodChange = (e) => {
    const value = e.target.value;
    setMethod(value);

    // Method Validation
    if (value === '') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        method: 'Method is required.',
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, method: '' }));
    }
  };

  const handleNotesChange = (e) => {
    const value = e.target.value;
    setNotes(value);

    // Notes Validation
    if (value.trim() === '') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        notes: (
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '12px', fontWeight: 500 }}
          >
            Notes required.
          </Typography>
        ),
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, notes: '' }));
    }
  };

  const handleSubmit = () => {
    if (
      amount === '' ||
      amount == 0 ||
      amount == null ||
      method === '' ||
      notes.trim() === ''
    ) {
      setErrors({
        amount:
          amount === '' || amount == 0 || amount == null ? (
            <Typography
              sx={{ fontFamily: 'poppins', fontSize: '12px', fontWeight: 500 }}
            >
              Amount is required.
            </Typography>
          ) : (
            ''
          ),
        method:
          method === '' ? (
            <Typography
              sx={{ fontFamily: 'poppins', fontSize: '12px', fontWeight: 500 }}
            >
              Method is required.
            </Typography>
          ) : (
            ''
          ),
        notes:
          notes.trim() === '' ? (
            <Typography
              sx={{ fontFamily: 'poppins', fontSize: '12px', fontWeight: 500 }}
            >
              {' '}
              Notes are required.
            </Typography>
          ) : (
            ''
          ),
      });
      return false; // Validation failed
    }

    return true; // Validation passed
  };

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForDepositBuyerAck))
      Moxoseparationinlisting(
        'dataForDepositBuyerAck',
        res?.data?.dataForDepositBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //2
  };

  const params = useParams();
  const propertyId = Number(params?.dashboardId);

  const buyerName = isDetailsIndividual
    ? confirmAmount?.buyerName + ' ' + confirmAmount?.buyerSurName
    : actionBuyer?.buyerName;

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const { bannerApiTrigger } = useContext(datacontext);

  const reqdeposit = () => {
    setContractAppLoader(true);
    // setActionBuyerId("");
    // setActionBuyer("");
    const inputData = {
      buyerId: actionBuyerId,
      propertyId: propertyId,
      isConfirmDeposit: 1,
      depositAmount: null,
      amountIn: null,
      settlementDays: 0,
      dueDate: null,
      trustAccName: 'AJ Real Estate Trust Account',
      bsb: '0191928',
      accNo: '019021928',
      depositType: null,
      message: notes,
      confirmAmount: amountInput,
      // confirmAmount: isDetailsIndividual
      //   ? confirmAmount?.unformattedNeedToConfirmAmount
      //   : Number(amountInput),
      confirmMethod: method,
    };
    postApiCall(REQUEST_DEPOSIT, inputData)
      .then((res) => {
        if (!isFromBuyerRegister) {
          getTableData();
          getListInfo();
        }
        if (isDetailsIndividual) {
          getDetailsData();
          getListInfo();
        }
        claerState();
        onClose();
        if (res?.data?.status == '1') {
          moxoapis(res);
          bannerApiTrigger();
          setContractAppLoader(false);
          setPaymentHistoryPopup(false);

          Swal.fire({
            title: res?.data?.heading,
            // text: res?.data?.message,
            // html: `Deposit payment has been requested from <b style="font-family: Poppins; font-weight: 550; color:#666666;">${buyerName}</b>.`,
            // html: `The Deposit payment has been confirmed as received and <b style="font-family: Poppins; font-weight: 550; color:#666666;">${buyerName}</b> has been notified.`,
            // message:res?.data?.message,
            html: `The deposit payment of <b>$${Number(
              amountInput || 0
            ).toLocaleString()}</b> has been confirmed as received. 
            Buyer <b>${buyerName}</b> has been notified.`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then(() => {
            setDisplayExchange(true);
          });
        } else {
          setContractAppLoader(false);
          setPaymentHistoryPopup(false);

          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then(() => {
            setDisplayExchange(true);
          });
        }
      })
      .catch(() => {
        setPaymentHistoryPopup(false);
        setContractAppLoader(false);
      });
  };

  useEffect(() => {
    if (contractAppLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [contractAppLoader]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          minWidth: matches800 ? '95%' : '500px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          paddingBottom: matches700 && '15px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid container xs={12} sx={{ padding: '30px' }}>
          <Grid item xs={12} sx={{ paddingBottom: '8px' }}>
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Payment History
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ paddingTop: '0px', paddingLeft: '12px' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Record payment details for this deposit.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="column"
          spacing={3}
          sx={{
            padding: isMobile ? '0 15px' : '20px 70px',
            mt: isMobile ? 0 : -5,
          }}
        >
          {/* Amount Field */}
          <Grid item container alignItems="center">
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  color: '#666666',
                }}
              >
                Amount:
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                value={
                  amount !== null
                    ? `$ ${amount?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : 0
                }
                onChange={handleAmountChange}
                fullWidth
                error={!!errors.amount}
                helperText={errors.amount}
                disabled={amount === 'undefined' || amount === null} // ⛔ Disable when API value is 0
                InputProps={{
                  sx: {
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                    height: '50px',
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* Method Field (Dropdown) */}
          <Grid item container alignItems="center">
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  color: '#666666',
                }}
              >
                Method
              </Typography>
            </Grid>

            <Grid item xs={9}>
              <Select
                variant="outlined"
                value={method}
                error={Boolean(errors.method)}
                onChange={handleMethodChange}
                fullWidth
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                  fontSize: '16px',
                  fontFamily: 'Poppins',
                  height: '50px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                  },
                  '& .MuiSelect-select': {
                    paddingRight: '48px',
                  },
                  '& .MuiSelect-icon': {
                    right: '8px',
                    color: '#666666',
                  },
                }}
              >
                {/* Removed disabled placeholder */}
                <MenuItem value="EFT">EFT</MenuItem>
                <MenuItem disabled value="Bank Transfer">
                  Bank Transfer
                </MenuItem>
              </Select>

              {errors.method && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 1, mt: 0.5 }}
                >
                  {errors.method}
                </Typography>
              )}
            </Grid>
          </Grid>

          {/* Notes Field */}
          <Grid item container alignItems="flex-start">
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  marginTop: '8px',
                  color: '#666666',
                }}
              >
                Message
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                value={notes}
                onChange={handleNotesChange}
                error={!!errors.notes}
                helperText={errors.notes}
                placeholder="Add any relevant payment notes"
                InputProps={{
                  sx: {
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent={matchessm ? 'center' : 'flex-end'}
          alignItems="center"
          gap={matchessm ? '8px' : 2}
          sx={{
            mt: matchessm ? '15px' : 3,
            mb: '30px',
            mr: matchessm ? 0 : '30px',
            flexWrap: 'wrap',
          }}
        >
          {/* Cancel Button */}
          <Grid item>
            <Button
              variant="outlined"
              disabled={contractAppLoader}
              fullWidth={matchessm}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => {
                onClose();
                claerState();
              }}
            >
              Cancel
            </Button>
          </Grid>

          {/* Confirm Button + Loader */}
          <Grid
            item
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <Button
              variant="outlined"
              disabled={
                contractAppLoader || amount === 'undefined' || amount === null
              }
              fullWidth={matchessm}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background:
                  contractAppLoader || amount === 'undefined' || amount === null
                    ? '#b0b0b0ff'
                    : '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
                opacity: contractAppLoader ? 0.7 : 1,
              }}
              onClick={() => {
                if (handleSubmit()) {
                  reqdeposit();
                }
              }}
            >
              Confirm
            </Button>

            {contractAppLoader && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: matchessm ? '35px' : '41px',
                  width: matchessm ? '35px' : '41px',
                }}
              >
                <img
                  alt="Loader"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default PaymentHistoryPopup;
